var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMustardIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 120.2 125.4",
    enableBackground: "new 0 0 120.2 125.4",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#DBA91A",
    d: "M112.2,46.3c-6.7-23.2-29.5-41-54.3-38c-0.1-0.2-0.3-0.2-0.6-0.2C34.7,10.6,16.4,27,9.7,48.4 c-0.8,2.7-1.5,5.4-2,8.2c-0.2,0.1-0.2,0.4-0.1,0.5c-0.2,1-0.3,2-0.4,3c-0.1,0.1-0.1,0.2,0,0.3c-0.8,7.3-0.4,14.8,1.7,21.8 c0.9,2.9,2,5.6,3.4,8.1c0,0.2,0.1,0.4,0.3,0.5c3.8,6.5,9.4,11.7,16,16c9.8,6.3,20.6,10.7,32.4,10.5c1.3,0,2.6-0.1,3.9-0.2 c0.2,0.2,0.7,0.2,0.8-0.1c8.9-0.9,17.7-4,25.3-8.8c9.9-6.2,17-14.6,20.5-25.8C115.1,70.8,115.6,58.1,112.2,46.3z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 39.9651,
    y1: 58.195,
    x2: 114.4187,
    y2: 82.6451
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0981162,
    style: {
      stopColor: "#664D12"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5531,
    style: {
      stopColor: "#AB821A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8216,
    style: {
      stopColor: "#DBA91A"
    }
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_1_)",
    d: "M49.3,98.1l37,12.7c1.6-0.8,3.1-1.7,4.6-2.6c9.9-6.2,17-14.6,20.5-25.8c3.3-10.5,4.1-21.9,1.7-32.6 L60.6,27.6L49.3,98.1z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    stroke: "#FFFFFF",
    strokeWidth: 2.7,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: " M68.1,44.6h-0.6c0.1-0.2,0.2-0.5,0.2-0.8v-2.7c0-1-0.8-1.8-1.8-1.8h-2c-0.2,0-0.3-0.1-0.4-0.3l-3.1-10.7c-0.1-0.4-0.7-0.4-0.8,0 l-3.1,11h-0.2h-2.2c-1,0-1.8,0.8-1.8,1.8v2.7c0,0.3,0.1,0.6,0.2,0.8h-0.6c-2.1,0-3.8,1.7-3.8,3.8v46.1c0,2.1,1.7,3.8,3.8,3.8h16.2 c2.1,0,3.8-1.7,3.8-3.8V48.3C71.8,46.2,70.1,44.6,68.1,44.6z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#DBA91A",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: " M51.8,44c0,0,8.3,3.4,16.5,0"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#DBA91A",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: " M56,38.6c0,0,5.2,1.8,8-0.4"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#DBA91A",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: " M52.5,47.5c0,0-3.2-0.2-3.2,5.1v19.9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMustardIcon);
export default __webpack_public_path__ + "static/media/mustard_icon.70d8750556d14ccde2011107e346ebaa.svg";
export { ForwardRef as ReactComponent };